import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { serviceOverviews } from '../data/serviceOverviews';
import '../styles/ServicesOverview.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

export default function ServicesOverview() {
  return (
    <section className="section services-overview">
      <div className="container">
        <motion.div className="services-overview__header" {...fadeUp(0)}>
          <div className="section__tag">What We Do</div>
          <h2 className="section__title">Services Overview</h2>
        </motion.div>

        <div className="services-overview__grid">
          {serviceOverviews.map((service, idx) => {
            const ServiceIcon = service.icon;
            return (
              <Link
                key={service.slug}
                to={`/services/${service.slug}`}
                className="service-card-link"
              >
                <motion.div
                  className="service-card"
                  {...fadeUp(idx * 0.08)}
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                >
                  {/* Top Accent Bar */}
                  <div
                    className="service-card__top-bar"
                    style={{ backgroundColor: service.accentColor }}
                  />

                  {/* Icon Section */}
                  <div className="service-card__icon-container">
                    <div
                      className="service-card__icon"
                      style={{
                        backgroundColor: service.accentColor + '15',
                        borderColor: service.accentColor + '30',
                      }}
                    >
                      <ServiceIcon size={36} color={service.accentColor} strokeWidth={1.5} />
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="service-card__content">
                    <h3 className="service-card__title">{service.title}</h3>
                    <p className="service-card__description">{service.description}</p>

                    <motion.div
                      className="service-card__link"
                      whileHover={{ x: 6 }}
                      transition={{ duration: 0.2 }}
                    >
                      <span>Explore</span>
                      <ArrowRight size={16} strokeWidth={2.5} />
                    </motion.div>
                  </div>
                </motion.div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
